import { toFlatJson } from "./FormData";

export function post(url, data, btns = null) {
  startLoading(btns);
  return $.ajax({
    url: url,
    type: 'POST',
    data: JSON.stringify(toFlatJson(data)),
    contentType: 'application/json'
  }).always(() => {
    stopLoading(btns);
  });
}

export function get(url, btns = null) {
  startLoading(btns);
  return $.get(url).always(() => {
    stopLoading(btns);
  });
}

function startLoading(btns = null) {
  if (btns !== null) {
    if (Array.isArray(btns)) {
      btns.map(onBtn => onBtn.loading());
    } else {
      btns.loading();
    }
  } else {
    $.loading();
  }
}

function stopLoading(btns = null) {
  if (btns !== null) {
    if (Array.isArray(btns)) {
      btns.map(onBtn => onBtn.loading('reset'));
    } else {
      btns.loading('reset');
    }
  } else {
    $.loading('reset-all');
  }
}